"use strict";

exports.__esModule = true;
var _ToolbarDescription = require("./ToolbarDescription");
Object.keys(_ToolbarDescription).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ToolbarDescription[key]) return;
  exports[key] = _ToolbarDescription[key];
});